import { EndPoints, get, post } from '../';
export function list() {
    return get(EndPoints.feed, { limit: 100 });
}
export function parse() {
    return post(EndPoints.feedParse, {});
}
